import { isFilterApplied } from "../../../../components/filters/ResourceSearchFilter/filterConfig"

export const checkIsFilterUsed = ({ searchParamGroup }) =>
  isFilterApplied(searchParamGroup)
